export default __webpack_public_path__ + "static/Filter-fd76c1ace0263793ac096f6e8b240a4f.png";